import { Component } from '@angular/core';
import { MENU_PAGE } from '../shared/defines/desktop.const';

@Component({
  selector: 'app-proper-wording',
  templateUrl: './proper-wording.component.html',
  styleUrls: ['./proper-wording.component.scss']
})
export class ProperWordingComponent {

  MENU_PAGE = MENU_PAGE;
}
